import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Metrics.module.scss';
import { IconChartBar } from '@tabler/icons-react';

const Metrics: React.FC = () => {
  const { t } = useTranslation('templates');
  return (
    <>
      <div className={styles.planHeader}>
        <div className={styles.planHeaderContent}>
          <h2 className={styles.planTitle}>{t('metrics.title')}</h2>
          <p className={styles.planDescription}>{t('metrics.description')}</p>
        </div>
      </div>

      <div className={styles.contentArea}>
        <div className={styles.placeholderContent}>
          <div className={styles.placeholderIcon}>
            <IconChartBar />
          </div>
          <h3 className={styles.placeholderTitle}>{t('metrics.comingSoon.title')}</h3>
          <p className={styles.placeholderText}>
            {t('metrics.comingSoon.text')}
          </p>
          <ul className={styles.placeholderList}>
            <li>{t('metrics.comingSoon.items.realtime')}</li>
            <li>{t('metrics.comingSoon.items.team')}</li>
            <li>{t('metrics.comingSoon.items.health')}</li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Metrics;
